import {
  SET_CATEGORIES,
  SET_SELECTED_LIBRARY,
  CLEAR_LIBRARY,
} from "../actions/library";

import { LOG_OUT } from "../actions/user";

const defaultState = {
  categories: [],
  selectedLibrary: null,
  selectedLibraryType: "",
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_CATEGORIES:
      return Object.assign({}, state, {
        categories: action.categories,
      });
    case SET_SELECTED_LIBRARY:
      return Object.assign({}, state, {
        selectedLibrary: action.library,
        selectedLibraryType: action.libraryType,
      });
    case CLEAR_LIBRARY:
      return Object.assign({}, state, {
        selectedLibrary: null,
        selectedLibraryType: "",
      });
    case LOG_OUT:
      return {
        categories: [],
        selectedLibrary: null,
        selectedLibraryType: "",
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/library.js